import script from "./DetailsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailsPage.vue?vue&type=script&lang=ts&setup=true"

import "./DetailsPage.vue?vue&type=style&index=0&id=4f46744a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f46744a"]])

export default __exports__